export default class AppProgress {
    isDefault(){
        return "progress"
    }

    isSuccess(val){
        return val ? "progress is-success" : "progress"
    }

    isDanger(val){
        return val ? "progress is-danger" : "progress"
    }

    isWarning(val){
        return val ? "progress is-warning" : "progress"
    }

    isInfo(val){
        return val ? "progress is-info" : "progress"
    }

    isLink(val){
        return val ? "progress is-link" : "progress"
    }
}